import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import SEO from './components/SEO';
import Navigation from './components/Navigation';
import PurchaseSuccess from './components/PurchaseSuccess';
import Hero from './components/Hero';
import Workspace from './components/Workspace';
import Features from './components/Features';
import Meetings from './components/Meetings';
import HowItWorks from './components/HowItWorks';
import Comparison from './components/Comparison';
import Pricing from './components/Pricing';
import Faq from './components/Faq';
import Footer from './components/Footer';
import { initGA } from './utils/analytics';
import { logEnvironmentInfo } from './utils/environment';

function App() {
  useEffect(() => {
    initGA();
    if (process.env.NODE_ENV !== 'production') {
      logEnvironmentInfo();
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <SEO />
        <Navigation />
        <PurchaseSuccess />
        <main>
          <Hero />
          <Workspace />
          <Features />
          <Meetings />
          <HowItWorks />
          <Comparison />
          <Pricing />
          <Faq />
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
